import Fade from 'react-reveal/Fade';
import { useSite } from '../../context/SiteContext';
import Skeleton from 'react-loading-skeleton';

export function PersonalBankingSectionView({ onSignUp }) {
  const { bankingDetails, loading } = useSite();
  const personal = bankingDetails?.personal;

  return (
    <div id="personal" className="waya-personal-section">
      <div className="waya-two-col">
        <Fade left>
          <div style={{ flex: 1 }}>
            <span className="waya-eyebrow-personal">
              {loading ? <Skeleton width={100} /> : (personal?.sectionTagline || "Personal Banking")}
            </span>
            <h2 className="waya-section-heading" style={{ textAlign: 'left' }}>
              {loading ? <Skeleton width="80%" /> : (personal?.title || "Built for the market, not just the office.")}
            </h2>
            <p
              className="waya-section-subline"
              style={{ textAlign: 'left', marginLeft: 0 }}
            >
              {loading ? <Skeleton count={2} /> : (personal?.description || "WayaBank is also building for Mama Bisi. The tomato seller. The mama put owner. The market trader who has never been inside a bank branch and deserves one anyway.\n\nWhether you sell tomatoes or run a growing business, WayaBank works for you.")}
            </p>

            {loading ? (
              [1, 2, 3, 4].map(i => (
                <div key={i} className="waya-feature-bullet">
                  <Skeleton width={18} height={18} circle className="me-2" />
                  <Skeleton width="60%" height={14} />
                </div>
              ))
            ) : (
              (personal?.bullets || [
                'Open your account on your phone',
                'Accept payments on a POS',
                'Get real-time alerts before you release goods',
                'Keep a transaction record you can show when you need a loan',
                'WayaBank gives you legitimacy, and it gives it to you on your terms'
              ]).map((bullet, idx) => (
                <div key={idx} className="waya-feature-bullet">
                  <div className="waya-check-icon">✓</div>
                  <div className="waya-bullet-label">{bullet}</div>
                </div>
              ))
            )}

            <button className="waya-btn-primary mt-4" onClick={onSignUp}>
              {loading ? <Skeleton width={120} height={40} /> : (personal?.buttonText || "Open Personal Account")}
            </button>
          </div>
        </Fade>

        <Fade right>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
            {loading ? (
              <Skeleton width="100%" height={400} />
            ) : (
              <img
                src={personal?.image_url}
                alt="Personal Banking"
                className="waya-banking-img img-fluid"
                style={{
                  width: '100%',
                  maxWidth: '700px',
                  height: 'auto',
                }}
              />
            )}
          </div>
        </Fade>
      </div>
    </div>
  );
}
